import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Form as BootstrapForm } from "reactstrap";
import { RenderFields } from "../../utils/form.utils";
import { GroupBtn } from "../GroupBtn";

const Form = ({
  fields = [],
  schema = "",
  defaultValues = undefined,
  onSubmit = () => {},
  closebtnText = "Close",
  submitbtnText = "Submit",
  resetbtnText = "Reset",
  toggle = () => {},
  isReset = true,
  loading = false,
  onClose = () => {}
}) => {
  const formValues = {
    ...(defaultValues ? { defaultValues } : {}),
    ...(schema ? { resolver: yupResolver(schema) } : {})
  };

  const methods = useForm(formValues);

  const handleSubmit = methods.handleSubmit;
  const setValue = methods.setValue;
  const unregister = methods.unregister;
  const setError = methods.setError;
  const clearErrors = methods.clearErrors;
  const control = methods.control;
  const watch = methods.watch;
  const reset = methods.reset;
  const { errors } = methods.formState;

  const handleClose = () => {
    reset();
    toggle();
    onClose();
  };

  const handleReset = () => {
    reset();
  };

  const btns = [
    {
      name: closebtnText,
      color: "secondary",
      onClick: handleClose
    },
    isReset
      ? {
          name: resetbtnText,
          color: "danger",
          onClick: handleReset
        }
      : {},
    {
      name: submitbtnText,
      type: "submit",
      color: "primary"
    }
  ];

  return (
    <FormProvider {...methods}>
      <BootstrapForm onSubmit={handleSubmit(onSubmit)}>
        <RenderFields
          setValue={setValue}
          unregister={unregister}
          setError={setError}
          clearErrors={clearErrors}
          fields={fields}
          control={control}
          watch={watch}
          errors={errors}
        />
        <GroupBtn btns={btns} loading={loading} />
      </BootstrapForm>
    </FormProvider>
  );
};

export default Form;
